import { Controller } from "stimulus";

/** Launches merchant survey location selector dialog*/
export default class extends Controller {
  launchDialog() {
    document.querySelector("#feedback-dialog").showModal();
  }
}
